/**
 * @packageDocumentation
 * @module HackerAPI.Event.ActivityRedemption
 */
import { __extends } from "tslib";
import Base from "../../base/base";
import HackerAPIFetch from "../../hackerapi-fetch/hackerapi-fetch";
import { parseDate } from "../../utils/utils";
/**
 * A redemption for an activity
 * @constructor
 * @param
 */
var ActivityRedemption = /** @class */ (function (_super) {
    __extends(ActivityRedemption, _super);
    /**
     * Creates an ActivityRedemption instance
     * @constructor
     * @param redemption
     */
    function ActivityRedemption(_a) {
        var id = _a.id, event_activity_id = _a.event_activity_id, eventActivityId = _a.eventActivityId, user_id = _a.user_id, userId = _a.userId, volunteer_id = _a.volunteer_id, volunteerId = _a.volunteerId, scan_time = _a.scan_time, scanTime = _a.scanTime, override_reason = _a.override_reason, overrideReason = _a.overrideReason, scan_times = _a.scan_times, scanTimes = _a.scanTimes, badge_code = _a.badge_code, badgeCode = _a.badgeCode, name = _a.name;
        var _this = _super.call(this, {
            scanTime: Base.dateTimeHandler,
            scanTimes: Base.doNotSendHandler
        }) || this;
        /**
         * The ID of the activity redemption
         * @returns
         */
        _this.id = id;
        /**
         * @type { string }
         */
        _this.name = name;
        /**
         * The ID of the activity that this redemption is for
         * @returns
         */
        _this.eventActivityId = event_activity_id || eventActivityId;
        /**
         * The ID of the user that this activity redemption is for
         * @returns
         */
        _this.userId = user_id || userId;
        /**
         * The user ID of the volunteer that redeemed this activity
         * @returns
         */
        _this.volunteerId = volunteer_id || volunteerId;
        /**
         * The current activity redemption
         * @returns
         */
        _this.scanTime = parseDate(scan_time || scanTime);
        /**
         * All the redemptions for this activity
         * @returns
         */
        _this.scanTimes = (scan_times || scanTimes || []).map(function (t) { return new Date(t); });
        /**
         * The reason why a volunteer is overriding a redemption
         * @returns
         */
        _this.overrideReason = override_reason || overrideReason || null;
        /**
         * The badge code associated with a redemption
         * @type { string }
         */
        _this.badgeCode = badge_code || badgeCode;
        return _this;
    }
    /**
     * Fetches all a user's redemptions
     * @param event
     * @param redemption
     * @param [token]
     * @param [token.token]
     * @returns
     */
    ActivityRedemption.fetchAll = function (_a, redemption, token) {
        var slug = _a.slug;
        return HackerAPIFetch({
            path: "/v2/events/" + slug + "/activity-redemptions",
            method: "GET",
            params: redemption.toHackerAPIFormat(),
            token: token
        }).then(function (data) {
            return data.activity_redemptions.map(function (datum) { return new ActivityRedemption(datum); });
        });
    };
    /**
     * Creates a new redemption
     * @param event
     * @param redemption
     * @param [token]
     * @param [token.token]
     * @returns
     */
    ActivityRedemption.create = function (_a, redemption, token) {
        var slug = _a.slug;
        return HackerAPIFetch({
            path: "/v2/events/" + slug + "/activity-redemptions",
            method: "POST",
            body: redemption.toHackerAPIFormat(),
            token: token
        }).then(function (data) { return new ActivityRedemption(data); });
    };
    /**
     * Creates a new redemption
     * @param event
     * @param redemption
     * @param [token]
     * @param [token.token]
     * @returns
     */
    ActivityRedemption.delete = function (_a, _b, token) {
        var slug = _a.slug;
        var id = _b.id;
        return HackerAPIFetch({
            path: "/v2/events/" + slug + "/activity-redemptions/" + id,
            method: "DELETE",
            token: token
        });
    };
    return ActivityRedemption;
}(Base));
export default ActivityRedemption;
//# sourceMappingURL=activity-redemption.js.map